import { useField } from 'informed';
import { SortableList } from 'components/common';

interface Props {
  itemWithBorder?: boolean;
  labels: { [identifier: string]: string };
  field: string;
}

const SortableListInput = (props: Props) => {
  const { fieldApi, fieldState, render, userProps } = useField<
    (number | string)[]
  >({ ...props });

  const { itemWithBorder, labels } = userProps;

  const handleOrderChange = (identifiers: string[]) => {
    fieldApi.setValue(identifiers);
  };

  return render(
    <SortableList
      items={
        fieldState?.value?.map((itemIdentifier) => ({
          key: itemIdentifier,
          label: labels[itemIdentifier]
        })) || []
      }
      itemWithBorder={itemWithBorder}
      listId={`${props.field}-sortable-list-input`}
      onChange={handleOrderChange}
      syncWithParent={true}
    />
  );
};

export default SortableListInput;
